/* LJDA — MercadoPago Payment Brick v2 */
(function () {
  'use strict';

  const BRICK_CONTAINER = 'ljda-payment-brick';
  const PAYMENT_ENDPOINT = window.LJDA_MP_CONFIG?.apiEndpoint || '/apps/mp/payment';

  /* ── State ── */
  let brickController = null;
  let cartData = null;

  /* ── Boot ── */
  async function init() {
    const container = document.getElementById(BRICK_CONTAINER);
    if (!container) return;

    const publicKey = container.dataset.publicKey;
    const locale = container.dataset.locale || 'es-MX';

    if (!publicKey) {
      showError('Configuración incompleta. Contacta al soporte.');
      return;
    }

    const amountFromLiquid = Number(container.dataset.amount) || 0;
    setLoadingState(true);

    try {
      cartData = await fetchCart();
      if (!cartData || cartData.item_count === 0) {
        showError('Tu carrito está vacío.');
        return;
      }
      await loadMPScript();
      await mountBrick(publicKey, locale, cartData, amountFromLiquid);
    } catch (err) {
      console.error('[LJDA MP Brick]', err);
      showError('No se pudo cargar el formulario de pago. Intenta de nuevo.');
    } finally {
      setLoadingState(false);
    }
  }

  /* ── Cart ── */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(r => r.json());
  }

  /* ── MP SDK loader ── */
  function loadMPScript() {
    if (window.MercadoPago) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://sdk.mercadopago.com/js/v2';
      s.onload = resolve;
      s.onerror = () => reject(new Error('MP SDK failed to load'));
      document.head.appendChild(s);
    });
  }

  /* ── Brick mount ── */
  async function mountBrick(publicKey, locale, cart, liquidAmount) {
    if (brickController) {
      await brickController.unmount();
      brickController = null;
    }

    const mp = new window.MercadoPago(publicKey, { locale });
    const builder = mp.bricks();

    const amountMXN = liquidAmount > 0 ? liquidAmount : Number((cart.total_price / 100).toFixed(2));
    console.log('[LJDA MP Brick] amount:', amountMXN);

    if (!amountMXN || amountMXN < 1) {
      showError('El monto del carrito no es válido.');
      return;
    }

    const settings = {
      initialization: {
        amount: amountMXN,
      },
      customization: {
        visual: {
          hideFormTitle: true,
          style: {
            customVariables: {
              baseColor: '#ff4d8d',
              baseColorFirstVariant: '#e6396f',
              baseColorSecondVariant: 'rgba(255,77,141,0.08)',
              fontSizeExtraSmall: '11px',
              fontSizeSmall: '13px',
              fontSizeMedium: '14px',
              fontSizeLarge: '16px',
              borderRadiusSmall: '6px',
              borderRadiusMedium: '12px',
              borderRadiusLarge: '12px',
              formPadding: '0px',
            },
          },
        },
        paymentMethods: {
          creditCard: 'all',
          debitCard: 'all',
        },
      },
      callbacks: {
        onReady: () => {
          document.getElementById('ljda-brick-skeleton')?.remove();
        },
        onSubmit: ({ selectedPaymentMethod, formData }) => {
          return handleSubmit(formData, cart);
        },
        onError: (error) => {
          if (error.type !== 'non_critical') {
            console.error('[LJDA MP Brick] error type:', error.type, '| cause:', error.cause, '| message:', error.message, error);
          }
        },
        onClickEditShippingData: () => {
          window.location.href = '/cart';
        },
      },
    };

    brickController = await builder.create('payment', BRICK_CONTAINER, settings);
  }

  /* ── Payment submit ── */
  async function handleSubmit(formData, cart) {
    const btn = document.getElementById('ljda-pay-btn');
    setPayBtnState(btn, 'loading');

    try {
      const payload = {
        formData,
        cartToken: cart.token,
        cartTotal: cart.total_price,
        currency: 'MXN',
        items: cart.items.map(i => ({
          id: i.variant_id,
          title: i.title,
          quantity: i.quantity,
          unit_price: i.price / 100,
        })),
        customer: buildPayerFromMeta(),
        returnUrl: `${window.location.origin}/pages/pago-confirmado`,
      };

      const res = await fetch(PAYMENT_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Cart-Token': cart.token,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || 'Error procesando el pago');
      }

      if (data.status === 'approved' || data.status === 'pending') {
        window.location.href = data.redirectUrl || '/pages/pago-confirmado?order=' + data.orderId;
        return;
      }

      if (data.status === 'in_process') {
        window.location.href = '/pages/pago-pendiente?ref=' + data.paymentId;
        return;
      }

      setPayBtnState(btn, 'error');
      showPaymentError(data.status, data.statusDetail);

    } catch (err) {
      console.error('[LJDA MP Brick] submit error:', err);
      setPayBtnState(btn, 'error');
      showPaymentError('error', err.message);
    }
  }

  /* ── Payer from page meta ── */
  function buildPayerFromMeta() {
    const meta = window.meta || {};
    return {
      firstName: meta.first_name || '',
      lastName: meta.last_name || '',
      email: meta.email || document.querySelector('[name="checkout[email]"]')?.value || '',
      address: {
        zipCode: meta.zip || '',
      },
    };
  }

  /* ── UI helpers ── */
  function setLoadingState(loading) {
    const skeleton = document.getElementById('ljda-brick-skeleton');
    if (skeleton) skeleton.style.display = loading ? 'block' : 'none';
  }

  function setPayBtnState(btn, state) {
    if (!btn) return;
    const states = {
      idle: { disabled: false, text: 'Pagar ahora' },
      loading: { disabled: true, text: 'Procesando...' },
      error: { disabled: false, text: 'Intentar de nuevo' },
    };
    const s = states[state] || states.idle;
    btn.disabled = s.disabled;
    btn.querySelector('span').textContent = s.text;
    btn.dataset.state = state;
  }

  function showError(msg) {
    const el = document.getElementById('ljda-mp-error');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  const ERROR_MESSAGES = {
    cc_rejected_bad_filled_card_number: 'Número de tarjeta incorrecto.',
    cc_rejected_bad_filled_date: 'Fecha de vencimiento incorrecta.',
    cc_rejected_bad_filled_other: 'Datos de tarjeta incorrectos.',
    cc_rejected_bad_filled_security_code: 'Código de seguridad incorrecto.',
    cc_rejected_blacklist: 'Tarjeta no permitida. Intenta con otra.',
    cc_rejected_call_for_authorize: 'Tu banco requiere autorización. Llámales e intenta de nuevo.',
    cc_rejected_card_disabled: 'Tarjeta inhabilitada. Contacta a tu banco.',
    cc_rejected_duplicated_payment: 'Este pago ya fue procesado anteriormente.',
    cc_rejected_high_risk: 'Pago rechazado por seguridad. Intenta con otro método.',
    cc_rejected_insufficient_amount: 'Fondos insuficientes.',
    cc_rejected_invalid_installments: 'Número de cuotas no válido para esta tarjeta.',
    cc_rejected_max_attempts: 'Alcanzaste el límite de intentos. Intenta mañana.',
    pending_contingency: 'Pago en proceso. Te notificaremos pronto.',
    pending_review_manual: 'Pago en revisión. Te notificaremos en hasta 2 días hábiles.',
  };

  function showPaymentError(status, detail) {
    const msg = ERROR_MESSAGES[detail]
      || (status === 'rejected' ? 'Pago rechazado. Verifica tus datos o intenta con otra tarjeta.' : 'Ocurrió un error. Intenta de nuevo.');
    showError(msg);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
